<template>
  <b-container fluid>
    <b-breadcrumb>
      <b-breadcrumb-item
        to="/dashboard"
        v-if="userType == 3"
      >
        <b-icon
          icon="house-fill"
          scale="1.25"
          shift-v="1.25"
          aria-hidden="true"
        />&nbsp;{{this.$t("dashboard")}}
      </b-breadcrumb-item>
      <b-breadcrumb-item
        v-if="userType == 3"
        to="/employee-approvals"
      >{{$t("approvals.myApprovals")}}</b-breadcrumb-item>
      <b-breadcrumb-item
        v-if="userType != 3 && this.$store.state.selectedTaskType == 'Tasks'"
        to="/tasks"
      >{{this.$store.state.selectedTaskType}}</b-breadcrumb-item>
      <b-breadcrumb-item
        v-if="userType != 3 && this.$store.state.selectedTaskType == 'Approval List'"
        to="/employee-approval-list"
      >{{this.$store.state.selectedTaskType}}</b-breadcrumb-item>
      <b-breadcrumb-item active>
        {{$t("approvals.approvalDetail")}}
        <!-- <strong>Requested by :</strong>
        {{approvalData.first_name + ' ' + approvalData.last_name}}-->
      </b-breadcrumb-item>
    </b-breadcrumb>

    <b-row>
      <b-col
        cols="4"
        style="height: calc(100vh - 170px); overflow-y: auto;"
      >
        <b-overlay
          :show="isLoading"
          rounded="sm"
        >
          <b-card class="text-left">
            <!-- <template v-slot:header>
              <h6 class="text-left">Details</h6>
            </template> -->

            <h5 class="text-left"><strong>{{$t("approvals.details")}}</strong></h5>
            <p>
              <strong>{{$t("approvals.ref")}} :</strong>
              {{approvalData.id}}
            </p>
            <p>
              <strong>{{$t("remingtonSeed.status")}} :</strong>&nbsp;
              <b-badge
                v-if="approvalData.status == 1"
                variant="info"
              >{{$t("remingtonSeed.Open")}}</b-badge>
              <b-badge
                v-else-if="approvalData.status == 2"
                variant="warning"
              >{{$t("approvals.Completed")}} </b-badge>
              <b-badge
                v-else-if="approvalData.status == 3"
                variant="warning"
              >{{$t("remingtonSeed.onHold")}} </b-badge>
              <b-badge
                v-else-if="approvalData.status == 4"
                variant="success"
              >{{$t("approvals.Approved")}}</b-badge>
              <b-badge
                v-else-if="approvalData.status == 5"
                variant="danger"
              >{{$t("approvals.Rejected")}}</b-badge>
              <b-badge
                v-else-if="approvalData.status == 6"
                variant="warning"
              >{{$t("approvals.InReview")}}</b-badge>
            </p>
            <p>
              <strong>{{$t("approvals.currency")}} :</strong>
              {{approvalData.currency}}
            </p>
            <p>
              <strong>{{$t("approvals.requestedBy")}} :</strong>
              {{approvalData.first_name + ' ' + approvalData.last_name}}
            </p>
            <p>
              <strong>{{$t("approvals.businessUnit")}} :</strong>
              {{approvalData.department}}
            </p>
            <p>
              <strong>{{$t("approvals.approvalType")}} :</strong>
              {{ JSON.parse(approvalData.title)[selectedLanguage] }}
            </p>
            <p>
              <strong>{{$t("approvals.createdDate")}} :</strong>
              {{dateFormat(approvalData.created_at)}}
            </p>
            <p>
              <strong>{{$t("approvals.ammount")}} :</strong>
              {{approvalData.amount}}
            </p>
            <div
              style="margin-bottom: 40px;margin-top: 5px;"
              v-if="employeeuserOnly == 1"
            >
              <!-- v-if="approvedGift" -->
              <b-button
                class="float-right mr-2"
                variant="outline-success"
                size="sm"
                @click="onShowNoteModal('Approve')"
              >Approve</b-button>
              <!-- v-if="rejectedGift" -->
              <b-button
                class="float-right mr-2"
                variant="outline-danger"
                size="sm"
                @click="onShowNoteModal('Reject')"
              >Reject</b-button>
              <b-button
                class="float-right mr-2"
                variant="outline-warning"
                size="sm"
                @click="onShowNoteModal('Require Additional Information')"
              >Require Additional Information</b-button>
            </div>
            <p>
              <!-- <b-row>
                  <b-col
                    cols="4"
                    class="pr-0"
                  >
                    <strong>Description :</strong>
                  </b-col>
                  <b-col
                    cols="8"
                    class="px-0"
                  >
                    <b-form-group v-if="enableEmployeeMoreInformation">
                      <b-form-textarea
                        size="sm"
                        v-model="employeeMoreInformation"
                        placeholder="Enter More Information"
                      ></b-form-textarea>
                    </b-form-group>
                    <span v-else>
                      {{approvalData.meta_data ? JSON.parse(approvalData.meta_data).description : ""}}
                    </span>
                  </b-col>
                </b-row> -->
            </p>
            <!-- <p>Due Date = 10/5/2020</p> -->

          </b-card>
        </b-overlay>
        <b-card
          v-if="userType != 3"
          class="mt-3"
          no-body
        >
          <b-card-title>Approvers</b-card-title>
          <b-card-body style="display: flex;justify-content: center;">
            <b-overlay
              :show="isLoadingApprovalTask"
              rounded="sm"
            >
              <b-table-simple
                borderless
                small
              >
                <b-thead>
                  <b-tr>
                    <b-th>Approver</b-th>
                    <b-th>Status</b-th>
                    <b-th>Date</b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr
                    v-for="(tasks, tasksIndex) in approvalTaskDetail"
                    :key="tasksIndex"
                  >
                    <b-td>
                      <b-avatar
                        v-if="tasks.first_name && tasks.last_name && tasks.profile_img_url == null"
                        variant="success"
                        v-b-tooltip.hover.bottom="tasks.first_name+' '+tasks.last_name"
                      >{{getApproverName(tasks)}}</b-avatar>
                      <b-avatar
                        v-else-if="tasks.profile_img_url"
                        variant="info"
                        :src="tasks.profile_img_url"
                      ></b-avatar>
                    </b-td>
                    <b-td>
                      <b-badge
                        v-if="tasks.status == '0'"
                        variant="info"
                      >Pending</b-badge>
                      <b-badge
                        v-if="tasks.status == '1'"
                        variant="success"
                      >Approved</b-badge>
                      <b-badge
                        v-if="tasks.status == '2'"
                        variant="danger"
                      >Rejected</b-badge>
                      <b-badge
                        v-if="tasks.status == '3'"
                        variant="warning"
                      >In Progress</b-badge>
                    </b-td>
                    <b-td>{{tasks.approved_at ? tasks.approved_at : 'N/A'}}</b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-overlay>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
        cols="8"
        style="height: calc(100vh - 170px); overflow-y: auto;"
      >
        <b-card class="shadow-sm">
          <b-tabs>
            <!-- :title="{{$t("approvals.Details")}}" -->
            <b-tab
              :title="$t('approvals.Details')"
              active
              :style="employeeuserOnly == 2 && approvalData.status == 3 ? 'height: calc(100vh - 215px); overflow: hidden auto;' : 'height: calc(100vh - 230px); overflow: hidden auto;'"
            >
              <b-modal
                :title="addNoteTitle"
                v-model="showAddNotesModal"
                size="lg"
                scrollable
                no-close-on-backdrop
                no-close-on-esc
                hide-header-close
              >
                <div>
                  <div
                    class="text-center"
                    v-if="!submiting && !responseSuccess"
                  >
                    <label v-if="notesStatus == 3">
                      Please Enter Additional Information:
                      <span class="required-span">*</span>
                    </label>
                    <label v-if="notesStatus == 2">
                      Please Enter the resons for your Rejection:
                      <span class="required-span">*</span>
                    </label>
                    <wysiwyg
                      :class="invalidApproveNotes != null ? 'approve-notes' : ''"
                      v-model="notesInput"
                    />
                    <p
                      v-if="invalidApproveNotes"
                      class="text-danger text-center mt-1"
                    >{{invalidApproveNotes}}</p>
                  </div>
                  <div v-else-if="submiting && !responseSuccess">
                    <p>Your Notes is being adding......</p>
                    <b-spinner
                      type="grow"
                      label="Loading..."
                    ></b-spinner>
                  </div>
                  <div v-else>
                    <p class="my-2 text-center">
                      Your Note has been Added successfully.
                      <br />
                    </p>
                  </div>
                </div>
                <template v-slot:modal-footer>
                  <b-button
                    v-if="!submiting"
                    @click="closeModal"
                    variant="outline-danger"
                  >Close</b-button>
                  <b-button
                    v-if="!submiting && !responseSuccess"
                    @click="addNotes"
                    variant="outline-success"
                  >{{notesStatus == 3 ? 'Send' : notesStatus == 2 ? 'Reject' : 'Approve'}}</b-button>
                </template>
              </b-modal>
              <div
                class="mt-3"
                v-if="!isLoadingFormData"
              >
                <!-- Form Rander Here -->
                <div v-if="employeeuserOnly == 2 && approvalData.status == 3">
                  <EmployeeApprovalFormUpdate
                    :formData="$store.state.form1"
                    :isLoadingForm="isLoadingFormData"
                    :isDisabled="0"
                  />
                </div>
                <div v-else>
                  <EmployeeApprovalForm
                    :form="$store.state.form1"
                    :isLoading="isLoadingFormData"
                    :isDisabled="1"
                    :selectedLanguage="selectedLanguage"
                  />
                </div>
              </div>

            </b-tab>
            <b-tab
              v-if="employeeuserOnly == 1"
              title="DOCUMENTS"
              :lazy="fileUploadTabLazy"
              style="height: calc(100vh - 180px); overflow: hidden auto;"
            >
              <b-overlay
                :show="isLoadingApprovalFiles"
                rounded="sm"
              >
                <div style="height: calc(100vh - 235px);overflow-y: auto;overflow-x: hidden;">
                  <b-navbar
                    toggleable="lg"
                    type="dark"
                    variant="light"
                  >
                    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                    <b-navbar-brand
                      href="#"
                      class="text-dark"
                    >
                      <strong>Approval Files</strong>
                    </b-navbar-brand>

                    <b-collapse
                      id="nav-collapse"
                      is-nav
                    >
                      <b-navbar-nav class="ml-auto">
                        <b-nav-form>
                          <b-button
                            @click="showUploadModal = !showUploadModal"
                            class="my-2 my-sm-0 mr-2"
                            variant="outline-primary"
                            size="sm"
                          >
                            Add File
                            <!-- <font-awesome-icon icon="plus" /> -->
                          </b-button>
                          <b-button
                            variant="outline-info"
                            size="sm"
                            class="mr-2"
                            @click="reloadTableFilesTable"
                          >
                            Reload
                            <!-- <font-awesome-icon icon="sync" /> -->
                          </b-button>
                        </b-nav-form>
                      </b-navbar-nav>
                    </b-collapse>
                  </b-navbar>
                  <b-table
                    bordered
                    class="mx-1"
                    sticky-header="calc(100vh - 220px)"
                    ref="table"
                    id="my-approval-files-table"
                    :busy.sync="isLoadingApprovalFiles"
                    :fields="filesTableFields"
                    :items="getApprovalFiles"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    no-sort-reset
                  >
                    <template v-slot:cell(created_at)="data">
                      <p>{{ createdAtDate(data.item.created_at) }}</p>
                    </template>
                    <template v-slot:cell(contact_name)="data">{{data.item.first_name + ' ' + data.item.last_name}}</template>
                    <template v-slot:cell(actions)="data">
                      <b-btn
                        size="sm"
                        variant="outline-danger"
                        @click="downloadFile(data)"
                      >
                        <font-awesome-icon icon="download" />
                      </b-btn>
                    </template>
                  </b-table>
                  <p class="mt-3">Current Page: {{ perPage }} rows</p>
                  <b-row>
                    <b-col cols="2">
                      <b-form-select
                        v-model="perPage"
                        id="perPageSelect"
                        size="sm"
                        :options="pageOptions"
                      ></b-form-select>
                    </b-col>
                    <b-col>
                      <b-pagination
                        class="float-right"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        first-text="First"
                        prev-text="Prev"
                        next-text="Next"
                        last-text="Last"
                        aria-controls="my-approval-files-table"
                      ></b-pagination>
                    </b-col>
                  </b-row>
                </div>
              </b-overlay>
              <b-modal
                title="File Upload"
                v-model="showUploadModal"
                size="lg"
                scrollable
                no-close-on-backdrop
                no-close-on-esc
                hide-header-close
              >
                <div>
                  <div
                    class="text-center"
                    v-if="!submiting && !responseSuccess"
                  >
                    <vue-dropzone
                      ref="myVueDropzone"
                      id="dropzone"
                      v-on:vdropzone-sending="sendingEvent"
                      @vdropzone-success="vsuccess"
                      :options="dropzoneOptions"
                      :useCustomSlot="true"
                      class="m-5 p-3"
                      style="border:dashed 1px"
                    >
                      <div class="dropzone-custom-content">
                        <h3 class="dropzone-custom-title">Drag and drop to upload content!</h3>
                        <div class="subtitle">...or click to select a file from your computer</div>
                      </div>
                    </vue-dropzone>
                    <b-form-group
                      label-cols-sm="4"
                      label-cols-lg="3"
                      label="Display Name"
                    >
                      <b-form-input
                        type="text"
                        v-model="uploadFileDisplayName"
                        size="sm"
                        :state="displayNameHasXss ? false : null"
                      />
                      <b-form-invalid-feedback>{{ $t( "createProfile.invalidInputMessage" ) }}</b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                  <div v-else-if="submiting && !responseSuccess">
                    <p>Your File is being Uploading......</p>
                    <b-spinner
                      type="grow"
                      label="Loading..."
                    ></b-spinner>
                  </div>
                  <div v-else>
                    <p class="my-2 text-center">
                      Your File has been uploaded successfully.
                      <br />
                    </p>
                  </div>
                </div>
                <template v-slot:modal-footer>
                  <div class="float-right">
                    <b-button
                      class="mr-3"
                      variant="outline-danger"
                      v-if="!uploading"
                      @click="resetUploadModal"
                    >Close</b-button>
                    <b-button
                      variant="outline-success"
                      v-if="!uploading && !responseSuccess"
                      @click="uploadFileApiCall"
                    >Upload</b-button>
                  </div>
                </template>
              </b-modal>
            </b-tab>
            <b-tab
              v-if="userType != 3"
              title="HISTORY"
              :lazy="employeeApprovalsTabLazy"
              style="height: calc(100vh - 180px); overflow: hidden auto;"
            >
              <b-overlay
                :show="isLoadingEmployeeApprovals"
                rounded="sm"
              >
                <b-navbar
                  toggleable="lg"
                  type="dark"
                  variant="light"
                >
                  <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
                  <b-navbar-brand
                    href="#"
                    class="text-dark"
                  >
                    <strong>Approval History</strong>
                  </b-navbar-brand>

                  <b-collapse
                    id="nav-collapse"
                    is-nav
                  >
                    <!-- Right aligned nav items -->
                    <b-navbar-nav class="ml-auto">
                      <b-nav-form>
                        <b-button
                          variant="outline-info"
                          size="sm"
                          class="mr-2"
                          @click="reloadTableEmployeeApprovals"
                        >
                          Reload
                          <!-- <font-awesome-icon icon="sync" /> -->
                        </b-button>
                        <b-form-group>
                          <b-input-group size="sm">
                            <b-form-input
                              v-model="filter"
                              type="search"
                              id="filterInput"
                              placeholder="Type to Search"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button
                                :disabled="!filter"
                                @click="filter = ''"
                              >Clear</b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-nav-form>
                    </b-navbar-nav>
                  </b-collapse>
                </b-navbar>
                <b-table
                  class="mx-1"
                  sticky-header="calc(100vh - 220px)"
                  :busy.sync="isLoadingEmployeeApprovals"
                  bordered
                  fixed
                  ref="table"
                  id="my-employee-approvals-table"
                  :fields="employeeApprovalsFields"
                  :items="getEmployeeApprovalsData"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  no-sort-reset
                >
                  <template v-slot:cell(created_at)="data">{{ createdAtDate(data.item.created_at) }}</template>
                  <template v-slot:cell(title)="data">{{ JSON.parse(data.item.title)['english'] }}</template>
                  <template v-slot:cell(amount)="data">{{ amountFormmater(data) }}</template>

                  <template v-slot:cell(status)="data">
                    <b-badge
                      v-if="data.item.status == 1"
                      variant="info"
                    >OPEN</b-badge>
                    <b-badge
                      v-else-if="data.item.status == 2"
                      variant="warning"
                    >COMPLETED</b-badge>
                    <b-badge
                      v-else-if="data.item.status == 3"
                      variant="warning"
                    >ON-HOLD</b-badge>
                    <b-badge
                      v-else-if="data.item.status == 4"
                      variant="success"
                    >APPROVED</b-badge>
                    <b-badge
                      v-else-if="data.item.status == 5"
                      variant="danger"
                    >REJECTED</b-badge>
                    <b-badge
                      v-else-if="data.item.status == 6"
                      variant="warning"
                    >In Review</b-badge>
                    <font-awesome-icon
                      v-if="parseInt(data.item.filesCount) > 0"
                      class="ml-2"
                      icon="paperclip"
                    />
                  </template>
                  <template v-slot:cell(actions)="data">
                    <!-- :to="'/gifts-approval/'+data.item.id+'/1'" -->
                    <b-btn
                      size="sm"
                      variant="outline-warning"
                      @click="historyAction(data)"
                    >
                      <font-awesome-icon icon="eye" />
                    </b-btn>
                  </template>
                </b-table>
                <p class="mt-3">Current Page: {{ perPage }} rows</p>
                <b-row>
                  <b-col cols="2">
                    <b-form-select
                      v-model="perPage"
                      id="perPageSelect"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                  </b-col>
                  <b-col>
                    <b-pagination
                      class="float-right"
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      first-text="First"
                      prev-text="Prev"
                      next-text="Next"
                      last-text="Last"
                      aria-controls="my-employee-approvals-table"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </b-overlay>
            </b-tab>
            <b-tab
              v-if="userType != 3"
              title="LOGS"
              style="height: calc(100vh - 180px); overflow-y: auto;"
            >
              <b-card>
                <template v-slot:header>
                  <b-row>
                    <b-col cols="6">
                      <h6 class="text-left">Logs</h6>
                    </b-col>
                    <b-col cols="6">
                      <div class="float-right">
                        <b-button
                          variant="outline-info"
                          size="sm"
                          class="mr-2"
                          @click="getApproverNotesList"
                        >
                          Reload
                          <!-- <font-awesome-icon icon="sync" /> -->
                        </b-button>
                      </div>
                    </b-col>
                  </b-row>
                </template>
                <b-card-body>
                  <div
                    id="container"
                    class="scrollFlow"
                    style
                  >
                    <b-row>
                      <b-col cols="12">
                        <b-overlay
                          :show="isLoadingComments"
                          rounded="sm"
                        >
                          <div>
                            <ul
                              class="timeline"
                              style="margin-bottom: 50px;"
                            >
                              <li
                                v-for="(notes,index) in notesData"
                                :key="index"
                              >
                                <p class="text-muted">
                                  {{ formatDate(notes.created_at) }}&nbsp;{{notes.first_name + ' ' + notes.last_name}}
                                  <span v-if="notes.status == 1">
                                    has
                                    <b-badge variant="success">Approved</b-badge>
                                  </span>
                                  <span v-if="notes.status == 2">
                                    has
                                    <b-badge variant="danger">Rejected</b-badge>
                                  </span>
                                  <span v-if="notes.status == 3">
                                    has
                                    <b-badge variant="warning">Requested Additional Information</b-badge>
                                  </span>
                                </p>
                                <p v-html="sanitizeHtml(notes.note)"></p>
                              </li>
                            </ul>
                          </div>
                        </b-overlay>
                      </b-col>
                    </b-row>
                  </div>
                </b-card-body>
              </b-card>
            </b-tab>
            <b-tab
              v-if="userType == 3"
              :title="$t('certifications.notes')"
              style="height: calc(100vh - 180px); overflow-y: auto;"
            >
              <b-card>
                <template v-slot:header>
                  <b-row>
                    <b-col cols="6">
                      <h6 class="text-left">{{$t("certifications.notes")}}</h6>
                    </b-col>
                    <b-col cols="6">
                      <div class="float-right">
                        <b-button
                          variant="outline-info"
                          size="sm"
                          class="mr-2"
                          @click="getApproverNotesList"
                        >
                          {{$t("remingtonSeed.reload")}}
                          <!-- <font-awesome-icon icon="sync" /> -->
                        </b-button>
                      </div>
                    </b-col>
                  </b-row>
                </template>
                <b-card-body>
                  <div
                    id="container"
                    class="scrollFlow"
                    style
                  >
                    <b-row>
                      <b-col cols="12">
                        <b-overlay
                          :show="isLoadingComments"
                          rounded="sm"
                        >
                          <div>
                            <ul
                              class="timeline"
                              style="margin-bottom: 50px;"
                            >
                              <li
                                v-for="(notes,index) in notesData"
                                :key="index"
                              >
                                <p class="text-muted">
                                  {{ formatDate(notes.created_at) }}&nbsp;
                                  <span v-if="notes.status == 1">
                                    <b-badge variant="success">{{$t("approvals.Approved")}}</b-badge>
                                  </span>
                                  <span v-if="notes.status == 2">
                                    <b-badge variant="danger">{{$t("approvals.Rejected")}}</b-badge>
                                  </span>
                                  <span v-if="notes.status == 3">
                                    <!-- Requested Additional Information -->
                                    <b-badge variant="warning">{{$t("remingtonSeed.onHold")}}</b-badge>
                                  </span>
                                </p>
                                <p v-html="sanitizeHtml(notes.note)"></p>
                              </li>
                            </ul>
                          </div>
                        </b-overlay>
                      </b-col>
                    </b-row>
                  </div>
                </b-card-body>
              </b-card>
            </b-tab>
            <b-tab
              v-if="userType != 3"
              title="ACTIVITY"
              style="height: calc(100vh - 180px); overflow-y: auto;"
            >
              <b-card>
                <template v-slot:header>
                  <b-row>
                    <b-col cols="6">
                      <h6 class="text-left">Activity</h6>
                    </b-col>
                    <b-col cols="6">
                      <div class="float-right">
                        <b-button
                          variant="outline-info"
                          size="sm"
                          class="mr-2"
                          @click="getApprovalActivityLog"
                        >
                          Reload
                          <!-- <font-awesome-icon icon="sync" /> -->
                        </b-button>
                      </div>
                    </b-col>
                  </b-row>
                </template>
                <b-card-body>
                  <div
                    id="container"
                    class="scrollFlow"
                    style
                  >
                    <b-row>
                      <b-col cols="12">
                        <b-overlay
                          :show="isLoadingActivityLog"
                          rounded="sm"
                        >
                          <div>
                            <ul
                              class="timeline"
                              style="margin-bottom: 50px;"
                            >
                              <li
                                v-for="(logData,index) in activityLogData"
                                :key="index"
                              >
                                <p class="text-muted">{{ formatDate(logData.created_at) }}</p>
                                <p>{{logData.notes}}</p>
                              </li>
                            </ul>
                          </div>
                        </b-overlay>
                      </b-col>
                    </b-row>
                  </div>
                </b-card-body>
              </b-card>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { HTTP } from "../../utils/HTTP";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import VueDropzone from "../../components/Dropzone/VueDropzone";
import EmployeeApprovalForm from "./employeeApprovalForm.vue";
import EmployeeApprovalFormUpdate from "./employeeApprovalFormUpdate.vue";
import moment from "moment";
import "moment/locale/es";
import axios from "axios";
import config from "../../configs/config";
import { Helper, Validate } from "../../helpers";
import _ from "lodash";
import { EventBus } from "@/event-bus.js";
export default {
  name: "ViewComplaints",
  components: {
    EmployeeApprovalForm,
    EmployeeApprovalFormUpdate,
    VueDropzone,
  },
  data () {
    return {
      selectedLanguage: 'english',
      employeeMoreInformation: null,
      enableEmployeeMoreInformation: false,
      isLoadingUpdateComment: false,
      approvedGift: true,
      rejectedGift: true,
      employeeApprovalsTabLazy: true,
      isLoadingEmployeeApprovals: false,
      filter: null,
      employeeApprovalsFields: [
        {
          key: "created_at",
          label: "Age",
          sortable: true,
        },
        {
          key: "title",
          label: "Approval Type",
          sortable: true,
        },
        // { key: "currency", label: "Currency", sortable: true },
        {
          key: "amount",
          label: "Amount (USD)",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "actions",
          label: "Action",
          sortable: false,
        },
      ],
      fileUploadTabLazy: true,
      showAddNotesModal: false,
      showUploadModal: false,
      totalRows: 0,
      perPage: 10,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      filesTableFields: [
        {
          key: "created_at",
          label: "Uploaded At",
          sortable: true,
        },
        {
          key: "contact_name",
          label: "Employee",
          sortable: true,
        },
        {
          key: "display_name",
          label: "Display Name",
          sortable: true,
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
        },
      ],
      isLoadingApprovalFiles: false,
      isLoadingFormData: true,
      submiting: false,
      responseSuccess: false,
      uploading: false,
      invalidApproveNotes: null,
      approvalData: {},
      isLoading: false,
      isLoadingComments: false,
      notesInput: null,
      notesData: [],
      uploadFileDisplayName: null,
      dropzoneOptions: {
        url:
          process.env.VUE_APP_API_URL +
          "api/v1/approvals/files/upload/" +
          this.$route.params.approvalId,
        thumbnailWidth: 150,
        maxFilesize: 25,
        maxFiles: 1,
        addRemoveLinks: true,
        autoProcessQueue: false,
        headers: {
          Authorization: "Bearer " + localStorage.getItem( "accessToken" ),
        },
      },
      approvalTaskDetail: [],
      isLoadingApprovalTask: false,
      addNoteTitle: null,
      notesStatus: 0,
      employeeuserOnly: 0,
      activityLogSortBy: "id",
      activityLogSortDesc: true,
      isLoadingActivityLog: false,
      activityLogData: [],
      userType: null,
    };
  },
  computed: {
    displayNameHasXss () {
      return !Validate.noXSS( this.uploadFileDisplayName );
    },
    rows () {
      return this.totalRows;
    },
  },
  mounted () {
    this.userType = localStorage.getItem( "userType" );
    this.selectedLanguage = localStorage.getItem( "formDefaultLanguage" );
    this.employeeuserOnly = this.$route.params.userType;
    if ( this.$route.params.userType == 2 ) {
      this.$store.state.employeeDashboardTabIndex = 1;
    }
    this.getApprovalsDetail();
    this.getApproverNotesList();
    this.getApprovalTaskDetail();
    this.getApprovalActivityLog();
  },
  methods: {
    sanitizeHtml,
    showDescriptionInput () {
      this.enableEmployeeMoreInformation = true;
      this.employeeMoreInformation = this.approvalData.meta_data ? JSON.parse( this.approvalData.meta_data ).description : ""
    },
    historyAction ( data ) {
      window.location.href = '/gifts-approval/' + data.item.id + '/1';
    },
    async addEmployeeMoreInformation () {
      let formData = {
        approval_id: this.$route.params.approvalId,
        meta_data: {
          description: this.employeeMoreInformation,
        },
        user_id: localStorage.getItem( "userId" ),
      };
      try {
        this.isLoadingUpdateComment = true;
        await HTTP( "post", "api/v1/approvals/update/onhold",
          formData
        );
        this.isLoadingUpdateComment = false;
        this.enableEmployeeMoreInformation = false;
        Helper.makeToast(
          this.$bvToast,
          "success",
          "Information Has Been successfully Added"
        );
        this.getApprovalsDetail();
      } catch ( err ) {
        this.isLoadingUpdateComment = false;
        return [err];
      }
    },
    getApproverName ( data ) {
      let firstName = data.first_name.toUpperCase();
      let lastName = data.last_name.toUpperCase();
      let name = firstName.charAt( 0 ) + lastName.charAt( 0 );

      return name;
    },
    async getApprovalActivityLog () {
      let formData = {
        activity_log_model_id: this.$route.params.approvalId,
        activity_log_type: "Approvals",
        user_id: localStorage.getItem( "userId" ),
        sort:
          this.activityLogSortBy +
          "|" +
          ( this.activityLogSortDesc == true ? "desc" : "asc" ),
      };
      this.isLoadingActivityLog = true;
      let response = await HTTP(
        "post",
        "api/v1/activitylog/get/with/type",
        formData
      );
      try {
        this.activityLogData = response.data.data;
        this.isLoadingActivityLog = false;
      } catch ( err ) {
        this.isLoadingActivityLog = false;
        return [err];
      } finally {
        this.scrollToEnd();
        this.isLoadingActivityLog = false;
      }
    },
    scrollToEnd () {
      var container = this.$el.querySelector( "#container" );
      container.scrollTop = container.scrollHeight + 120;
    },
    onShowNoteModal ( title ) {
      this.showAddNotesModal = true;
      this.addNoteTitle = title;
      if ( title == "Approve" ) {
        this.notesStatus = 1;
      } else if ( title == "Reject" ) {
        this.notesStatus = 2;
      } else if ( title == "Require Additional Information" ) {
        this.notesStatus = 3;
      }
    },
    reloadTableEmployeeApprovals () {
      this.$root.$emit( "bv::refresh::table", "my-employee-approvals-table" );
    },
    async getEmployeeApprovalsData () {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + ( this.sortDesc == true ? "desc" : "asc" ),
        per_page: this.perPage,
        page: this.currentPage,
        employee_id: this.approvalData.employee_id,
      };
      this.isLoadingEmployeeApprovals = true;
      let response = await HTTP( "post", "api/v1/approvals/get", formData );
      try {
        this.totalRows = response.data.total;
        this.isLoadingEmployeeApprovals = false;
        this.employeeApprovalsTabLazy = false;
        return response.data.data;
      } catch ( err ) {
        this.isLoadingEmployeeApprovals = false;
        this.employeeApprovalsTabLazy = false;
        return [err];
      } finally {
        this.isLoadingEmployeeApprovals = false;
        this.employeeApprovalsTabLazy = false;
      }
    },
    createdAtDate ( value ) {
      moment.locale( "en" );
      return moment( value ).format( "DD/MM/YYYY" );
    },
    async getApprovalTaskDetail () {
      this.approvalTaskDetail = [];
      this.isLoadingApprovalTask = true;
      try {
        let result = await HTTP(
          "get",
          "api/v1/approvals/get/approval/tasks/Detail/" +
          this.$route.params.approvalId,
          null
        );
        this.approvalTaskDetail = result.data.approvaltasks;
        this.selectedLanguage = ( result.data.language ) ? result.data.language.toLowerCase() : localStorage.getItem( "formDefaultLanguage" );
        this.isLoadingApprovalTask = false;
      } catch ( error ) {
        this.isLoadingApprovalTask = false;
      }
    },
    reloadTableFilesTable () {
      this.$root.$emit( "bv::refresh::table", "my-approval-files-table" );
    },
    amountFormmater ( data ) {
      let amount = data.item.amount.replace( /\D/g, "" );
      return ( amount == '' ) ? 'N/A' : '$' + amount.replace( /\B(?=(\d{3})+(?!\d))/g, "," );
    },
    async getApprovalFiles () {
      let formData = {
        sort: this.sortBy + "|" + ( this.sortDesc == true ? "desc" : "asc" ),
        per_page: this.perPage,
        page: this.currentPage,
      };
      this.isLoadingApprovalFiles = true;
      let response = await HTTP(
        "post",
        "api/v1/approvals/get/files/" + this.$route.params.approvalId,
        formData
      );
      try {
        this.totalRows = response.data.total;
        this.isLoadingApprovalFiles = false;
        this.fileUploadTabLazy = false;
        return response.data.data;
      } catch ( err ) {
        this.isLoadingApprovalFiles = false;
        this.fileUploadTabLazy = false;
        return [err];
      } finally {
        this.isLoadingApprovalFiles = false;
        this.fileUploadTabLazy = false;
      }
    },
    formatDate ( value ) {
      if ( value ) {
        moment.locale( "en" );
        return moment( String( value ) ).format( "DD MMMM, YYYY - h:mm:ss" );
      }
    },
    dateFormat ( value ) {
      if ( value ) {
        moment.locale( "en" );
        return moment( String( value ) ).format( "DD/MM/YYYY" );
      }
    },
    async getApproverNotesList () {
      this.notesData = [];
      this.isLoadingComments = true;
      try {
        let result = await HTTP(
          "get",
          "api/v1/approvals/get/approver/notes/" +
          this.$route.params.approvalId,
          null
        );
        this.notesData = result.data.approvalNotes;
        let approvedGiftIndex = null;
        let rejectedGiftIndex = null;
        let employeeId = localStorage.getItem( "employeeId" );

        approvedGiftIndex = result.data.approvalNotes.findIndex(
          ( i ) => i.status == "1"
        );
        rejectedGiftIndex = result.data.approvalNotes.findIndex(
          ( i ) => i.status == "2"
        );
        if (
          result.data.approvalNotes[approvedGiftIndex].employee_id == employeeId
        ) {
          if ( approvedGiftIndex != -1 ) {
            this.approvedGift = false;
          } else {
            this.approvedGift = true;
          }
        } else {
          this.approvedGift = true;
        }
        if (
          result.data.approvalNotes[rejectedGiftIndex].employee_id == employeeId
        ) {
          if ( rejectedGiftIndex != -1 ) {
            this.rejectedGift = false;
          } else {
            this.rejectedGift = true;
          }
        } else {
          this.rejectedGift = true;
        }
        this.isLoadingComments = false;
      } catch ( error ) {
        this.isLoadingComments = false;
      }
    },
    addNotes () {
      if ( this.notesStatus == 1 ) {
        this.addApproverComments();
      } else {
        if ( this.notesInput != null ) {
          this.addApproverComments();
        } else {
          this.invalidApproveNotes = "Plase Enter Something.";
        }
      }
    },
    async addApproverComments () {
      let formData = {
        status: this.notesStatus,
        note: this.notesInput,
        user_id: localStorage.getItem( "userId" ),
        employee_id: localStorage.getItem( "employeeId" ),
        requester_employee_id: this.approvalData.employee_id,
      };
      try {
        this.submiting = true;
        this.isLoadingComments = true;
        await HTTP(
          "post",
          "api/v1/approvals/add/approver/notes/" +
          this.$route.params.approvalId,
          formData
        );
        this.submiting = false;
        this.responseSuccess = true;
        this.isLoadingComments = false;
        var data = {
          created_at: new Date(),
          note: this.notesInput,
        };
        this.notesData.push( data );
        this.notesInput = null;
        this.invalidApproveNotes = null;
        if(this.addNoteTitle != 'Require Additional Information' && (this.userType == 1 || this.userType == 2) ){
          this.updateComplaintCountSidebar();
        }
        this.getApproverNotesList();
        this.getApprovalTaskDetail();
        // this.getApprovalsDetail();
        this.getApprovalActivityLog();
        this.closeModal();
        Helper.makeToast(
          this.$bvToast,
          "success",
          "Note Has Been successfully Added"
        );
      } catch ( err ) {
        this.submiting = false;
        this.responseSuccess = true;
        this.isLoadingComments = false;
        return [err];
      }
    },
    async updateComplaintCountSidebar(){ 
      try {
        let result = await HTTP(
          "get",
          "api/v1/remaining/actions",
        );
        if ( result.data.status == 1 ) {
        EventBus.$emit(
        "onUpdateSidebarCount",
         result.data.pendingActionsCount
        );
        }
      } catch ( err ) {
        return [err];
      }
    },
    closeModal () {
      this.isLoadingComments = false;
      this.submiting = false;
      this.responseSuccess = false;
      this.showAddNotesModal = false;
      this.notesInput = null;
      this.invalidApproveNotes = null;
      this.notesStatus = 0;
    },
    async deleteNote ( notes ) {
      this.isLoadingComments = true;
      try {
        await HTTP(
          "get",
          "api/v1/approvals/delete/approver/notes/" + notes.id,
          null
        );
        this.isLoadingComments = false;
        this.getApproverNotesList();
      } catch ( error ) {
        this.isLoadingComments = false;
      }
    },
    setUserFormSchemaToStore () {
      let form = JSON.parse( localStorage.getItem( "activeFormSchema" ) );
      // let taskdata = JSON.parse(localStorage.getItem("taskFormData"));
      this.updateFormToStore( form );
    },
    updateFormToStore ( form ) {
      this.$store.state.form1 = form;
    },
    async getApprovalsDetail () {
      this.approvalData = {};
      let fromData = {
        approval_id: this.$route.params.approvalId,
        user_id: localStorage.getItem( "userId" ),
      };
      this.isLoading = true;
      let result = HTTP( "post", "api/v1/approvals/detail", fromData );
      return result
        .then( ( response ) => {
          this.approvalData = response.data;
          localStorage.setItem( "activeFormSchema", response.data.schema );
          this.setUserFormSchemaToStore();
          if ( response.data.form_data.length ) {
            this.$store.state.userFormSubmitArray = JSON.parse( response.data.form_data );
            this.$store.state.getUserFormSubmitArray = JSON.parse( response.data.form_data );
          }
          this.isLoading = false;
          this.isLoadingFormData = false;
        } )
        .catch( ( error ) => {
          this.isLoading = false;
          return [error];
        } );
    },
    uploadFileApiCall () {
      if ( this.displayNameHasXss ) {
        return;
      }
      if ( this.$refs.myVueDropzone.getQueuedFiles().length > 0 ) {
        this.uploading = true;
        this.$refs.myVueDropzone.processQueue();
      }
    },
    vsuccess () {
      this.uploading = false;
      this.submiting = false;
      this.responseSuccess = true;
      this.$bvToast.toast(
        "Your file has been successfully uploaded and is now processed",
        {
          title: "File Upload is complete",
          noAutoHide: false,
          appendToast: true,
        }
      );
      this.$refs.myVueDropzone.removeAllFiles();
      this.reloadTableFilesTable();
    },
    sendingEvent ( file, xhr, formData ) {
      formData.append( "employee_id", localStorage.getItem( "employeeId" ) );
      formData.append( "displayName", this.uploadFileDisplayName );
      formData.append( "user_id", localStorage.getItem( "userId" ) );
    },
    resetUploadModal () {
      this.isLoadingApprovalFiles = false;
      this.submiting = false;
      this.responseSuccess = false;
      this.showUploadModal = false;
      this.getApprovalActivityLog();
    },
    async downloadFile ( data ) {
      let titleForm = data.item.filename;
      axios( {
        url: config.API_URL + "api/v1/approvals/file/download/" + data.item.id,
        method: "POST",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + localStorage.getItem( "accessToken" ),
        },
      } )
        .then( ( response ) => {
          if ( window.navigator.msSaveOrOpenBlob ) {
            let blob = new Blob( [response.data] );
            // IE11
            window.navigator.msSaveOrOpenBlob( blob, titleForm );
            Helper.makeToast(
              this.$bvToast,
              "success",
              "File has been download successfully"
            );
            return;
          } else {
            const url = window.URL.createObjectURL( new Blob( [response.data] ) );
            const link = document.createElement( "a" );
            link.href = url;
            link.setAttribute( "download", titleForm ); //or any other extension
            document.body.appendChild( link );
            link.click();
            if ( response ) {
              Helper.makeToast(
                this.$bvToast,
                "success",
                "File has been download successfully"
              );
            }
          }
        } )
        .catch( ( error ) => {
          Helper.makeToast( this.$bvToast, "danger", "Unable to download file." );
          return [error];
        } );
    },
  },
};
</script>

<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";

.body-card {
  padding: 0;
}

.approve-notes {
  border: 2px solid rgb(200 39 51) !important;
}
</style>
